/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconArrowTop extends React.Component {
  render() {
    const iconClasses = classNames("icon arrow-top", this.props.className);

    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path
          d="M 14.984375 9 A 1.0001 1.0001 0 0 0 14.292969 9.2929688 L 4.2929688 19.292969 A 1.0001 1.0001 0 1 0 5.7070312 20.707031 L 15 11.414062 L 24.292969 20.707031 A 1.0001 1.0001 0 1 0 25.707031 19.292969 L 15.707031 9.2929688 A 1.0001 1.0001 0 0 0 14.984375 9 z"
          fontWeight="400"
          fontFamily="sans-serif"
          overflow="visible"
        />
      </svg>
    );
  }
}

IconArrowTop.defaultProps = {
  className: null
};

IconArrowTop.propTypes = {
  className: PropTypes.string
};

export default IconArrowTop;
